import React from 'react';
import './Title.css';
import PropTypes from 'prop-types';

export default function Title(props) {
    const {
        title, subtitle, titleSize, subtitleSize, gap, lineHeight, subtitleLineHeight, deleteSubtitle, children,
    } = props;

    return (
        <div className="title-container" style={{ gap: gap }}>
            <div className="text-title" style={{ fontSize: titleSize, lineHeight: lineHeight, fontFamily: 'Inter' }}>{title}</div>
            { subtitle && (
                <div className="supporting-text-title" style={{ fontSize: subtitleSize, lineHeight: subtitleLineHeight }}>{subtitle}</div>
            )}
            {
                deleteSubtitle && (
                    <div className="supporting-text-title" style={{ fontSize: subtitleSize, lineHeight: subtitleLineHeight }}>
                        {children}
                    </div>
                )
            }
        </div>
    );
}

Title.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    titleSize: PropTypes.string,
    subtitleSize: PropTypes.string,
    gap: PropTypes.string,
    lineHeight: PropTypes.string,
};